/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import Header from "../Shared/Header";
import CatalogWithoutImg from "../Shared/CatalogList/CatalogWitoutImg";
import Login from "./Login";
import SignUp from "./SignUp";



export const SiteLogin = () => {
  return (
    <React.Fragment>
      <Grid container direction={"column"} style={{backgroundColor:'#fff',maxWidth:'100vw',height:'100vh'}}>
        <Header />
     
       <div style={{display:'flex',justifyContent:'center',alignItems:'center',backgroundColor:'#fff',boxShadow: 'rgba(29, 29, 41, 0.1) 0px 0px 16px',width:'min-content',padding:'2rem',marginLeft:"auto",marginRight:'auto',marginTop:'auto',marginBottom:'auto',borderRadius:11}}>
        <div>
          <img src="/pexels-cottonbro-3585001.jpg" alt="home top" style={{borderRadius:11}} width={311} height={321}/>
        </div>
    
          <Login />
        
       </div>
      </Grid>
    </React.Fragment>
  );
};

export const SiteSignup = () => {
  return (
    <React.Fragment>
      <Grid container direction={"column"}>
        <Header />
        <CatalogWithoutImg />
        <Grid
          container
          spacing={2}
          direction={"row"}
          sx={{
          
            alignSelf: "center",


            
          }}
          style={{minHeight:'100vh'}}
        >
             <div style={{display:'flex',justifyContent:'center',alignItems:'center',backgroundColor:'#fff',boxShadow: 'rgba(29, 29, 41, 0.1) 0px 0px 16px',width:'min-content',padding:'2rem',marginLeft:"auto",marginRight:'auto',marginTop:'auto',marginBottom:'auto',borderRadius:11}}>
        <div>
          <img src="/pexels-cottonbro-3585001.jpg" alt="home top" style={{borderRadius:11}} width={311} height={321}/>
        </div>
          <SignUp />

            </div>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};
